import script from "./BlogArticle.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogArticle.vue?vue&type=script&setup=true&lang=js"

import "./BlogArticle.vue?vue&type=style&index=0&id=3aeb1663&lang=scss"

const __exports__ = script;

export default __exports__